<template>
  <div class="not-found">
    <div class="not-found__img">
      <img src="/images/espace.svg" alt="404">
    </div>

    <section class="section not-found__content">
      <h1 class="section__title"> OUPS! TU SEMBLES PERDUE </h1>
      <p class="section__text"> La page que tu cherches semble avoir été déplacée ou supprimée. </p>
      <p class="section__text">
        Explore plutôt les pages détaillées de chacun des événements grâce à la navigation ci-dessus ou retourne en terrain connu sur la page d’accueil!
      </p>

      <div>
        <button class="button -back" @click="$router.push('/')"> Retour à l'accueil </button>

      </div>
    </section>
  </div>
</template>

<script>

export default {
  name: 'NotFound'
}
</script>
